import React from 'react';
import { Link } from 'react-router-dom';

import useTranslation from '@hooks/useTranslation';

import SecurityInfoSkeleton from './SecurityInfoSkeleton';
import style from './style.module.scss';

interface IProps {
  isLoading: boolean;
  enabled2fa?: boolean;
}

const SecurityInfo: React.FC<IProps> = ({ enabled2fa, isLoading }) => {
  const { t } = useTranslation();

  const descriptionText = enabled2fa
    ? 'Two-Factor Authentication Enabled. Now, when logging in from a new device, we will request an entry code. You receive the entry code through the authentication app.'
    : 'Two-Factor Authentication helps safeguard your account by requiring an additional code when logging in from a new device.';
  const buttonText = enabled2fa ? 'Disable' : 'Enable';

  return (
    <div className={style.securityInfo}>
      <div className={style.securityInfoTitle}>{t('Security')}</div>
      {isLoading ? (
        <SecurityInfoSkeleton />
      ) : (
        <div className={style.securityInfoContainer}>
          <div className={style.authInfo}>
            <div className={style.authInfoTitle}>{t('Two-Factor Authentication')}</div>
            <div className={style.authInfoDescription}>{t(descriptionText)}</div>
          </div>
          <Link className={style.authInfoButton} to={`${APP_SSO_URL}2FA/settings`} target="_blank">
            {t(buttonText)}
          </Link>
        </div>
      )}
    </div>
  );
};

export default SecurityInfo;
